import type { AdminCategoryTreeNode } from "@/lib/admin-api-client";

/**
 * Porté à l'identique depuis apps/web/lib/admin-category-tree.ts (aucune
 * dépendance Next.js dans l'original). Aplatit l'arbre de catégories
 * (`GET /admin/categories`) en une liste ordonnée (parcours en profondeur)
 * adaptée à un `<select>` — chaque entrée porte son niveau pour permettre une
 * indentation visuelle (`"— ".repeat(level)`). Utilisé par les formulaires
 * produit (choix de `primaryCategoryId`) et par la page catégories (choix du
 * parent).
 *
 * Vit dans `components/admin/` (et non `src/lib/`) car ce lot ne doit
 * toucher que `src/pages/admin/**` et `src/components/admin/**` — cf. tâche.
 */
export interface FlatCategoryOption {
  id: string;
  name: string;
  level: number;
}

export function flattenCategoryTree(nodes: AdminCategoryTreeNode[]): FlatCategoryOption[] {
  const out: FlatCategoryOption[] = [];
  const visit = (list: AdminCategoryTreeNode[]) => {
    for (const node of list) {
      out.push({ id: node.id, name: node.name, level: node.level });
      if (node.children.length) visit(node.children);
    }
  };
  visit(nodes);
  return out;
}

export function countCategories(nodes: AdminCategoryTreeNode[]): number {
  return nodes.reduce((sum, n) => sum + 1 + countCategories(n.children), 0);
}
